module.exports = __webpack_public_path__ + "img/img_ch.d6130002.jpg";